import { Component, OnInit, forwardRef } from "@angular/core";
import { NavController, NavParams, ModalController, LoadingController, IonicModule, AlertInput } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ModalPessoaPage } from "../modal-pessoa/modal-pessoa.page";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { Router } from "@angular/router";
import { CommonModule, Location } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { AlertController } from "@ionic/angular/standalone";
import { InstituicaoProvider } from "src/app/services/instituicao/instituicao";
@Component({
  selector: "app-aniversariantes",
  templateUrl: "./aniversariantes.page.html",
  styleUrls: ["./aniversariantes.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LoadingSpinnerComponent,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    SemRegistroComponent,
    NomenclaturaPipe,
  ],
})
export class AniversariantesPage implements OnInit {
  aniversariantes: any = [];
  aniversariantesMes: any = [];
  mostrarContato: boolean = false;
  aniversarioTipo: string = "dia";
  pagination: any = { currentPage: 0, pageCount: 0 };
  idGrupo: any = "";
  dayMonth: any;
  toogle: boolean = true;
  listGrupo: any = [];
  periodo: string = this.translate.instant("mês");
  idGrupoF: any = 0;
  gruposList: any;
  filtroGrupo: any = { q: "", idGrupo: "", dayMonth: true, participante: 0 };
  filtro: any = { q: "", idGrupo: "", dayMonth: "", participante: 1 };
  currentUrl: boolean;
  loaded = false;
  fecharModal = false;
  notFound = false;
  grupoSelecionado = "";
  instituicaoList: any;
  idInstituicaoLogada: number;
  idInstituicaoFiltro: number;
  nomeInstituicaoFiltro: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    private translate: TranslateService,
    public router: Router,
    private location: Location,
    public userProvider: UserProvider,
    private alertCtrl: AlertController,
    public instituicaoProvider: InstituicaoProvider
  ) {
    this.currentUrl = this.location.path() === "/tabs/AniversariantesPage";

    this.userProvider.getDadosInstituicao().then((id) => {
      this.idInstituicaoLogada = id.id;
      this.idInstituicaoFiltro = id.id
    });

    this.buscaDiaMes();
    this.initPessoasGrupo();
    this.listInstituicao();
  }

  initPessoasGrupo() {
    this.pessoaProvider.getBuscaGrupos(this.filtroGrupo, this.pagination).subscribe((list) => {
      this.listGrupo = list.grupos;
      if (list.grupos.length === 0) {
        this.notFound = true;
      }

      this.idGrupo = "";
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  buscaDiaMes() {
    this.pessoaProvider.getAniversariantesMes(null).subscribe((data) => {
      this.aniversariantesMes = data.aniversariantes;
    });

    this.pessoaProvider.getAniversariantes(null).subscribe((data) => {
      this.aniversariantes = data.aniversariantes;
      this.mostrarContato = data.acessoContato;
    });
  }

  onSegmentChanged(segmentButton: any) {
    if (segmentButton.detail.value === "grupo") {
      let filtro: any = {
        q: "",
        idGrupo: "",
        dayMonth: this.toogle,
        participante: 0,
      };
      this.pessoaProvider.getBuscaGrupos(filtro, this.pagination).subscribe((list) => {
        this.listGrupo = list.grupos;
        this.idGrupo = "";
      });
    }
  }

  async openModalGrupo(pessoa: { idPessoa: string }): Promise<any> {
    if (!this.userProvider.hasPermissao("PESSOA_VISUALIZAR")) {
      return false;
    }

    const data = { idPessoa: pessoa.idPessoa };
    const modalPage = await this.modalCtrl.create({
      component: ModalPessoaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  async openModal(pessoa: { id: string }): Promise<any> {
    if (!this.userProvider.hasPermissao("PESSOA_VISUALIZAR")) {
      return false;
    }

    const data = { idPessoa: pessoa.id };
    const modalPage = await this.modalCtrl.create({
      component: ModalPessoaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  setConfig() {
    this.toogle = !this.toogle;
    this.periodo = this.toogle ? this.translate.instant("mês") : this.translate.instant("dia");
    this.filtroGrupo.dayMonth = this.toogle;

    if (this.filtroGrupo.idGrupo) {
      this.selecionar(this.filtroGrupo.idGrupo);
    } else {
      let filtro: any = {
        q: "",
        idGrupo: this.filtroGrupo.idGrupo,
        dayMonth: this.toogle,
        participante: 0,
      };
      this.pessoaProvider.getBuscaGrupos(filtro, this.pagination).subscribe((list) => {
        this.listGrupo = list.grupos;
      });
    }
  }

  async selectGrupo() {
    this.loadGrupos(null);
  }

  changeVincular() {
    this.onCancel();
    this.filtroGrupo = {
      q: "",
      idGrupo: "",
      dayMonth: this.toogle,
      participante: 0,
    };
    this.initPessoasGrupo();
  }

  selecionar(grupo: any, fecharModal: boolean = false) {
    this.grupoSelecionado = grupo.nome ? grupo.nome : this.grupoSelecionado;
    this.filtroGrupo.idGrupo = grupo.id ? grupo.id : grupo;

    this.pessoaProvider.getBuscaGrupos(this.filtroGrupo, this.pagination).subscribe((list) => {
      this.listGrupo = list.grupos;
    });

    if (fecharModal) {
      this.modalCtrl.dismiss();
    }
  }

  loadGrupos(infiniteScroll: any) {
    this.pagination.currentPage++;

    if (!infiniteScroll) {
      this.pagination = { currentPage: 0, pageCount: 10 };
    }

    this.pessoaProvider.getBuscaGrupos(this.filtro, this.pagination).subscribe((res) => {
      if (!infiniteScroll) {
        this.gruposList = [];
      }

      this.gruposList = this.gruposList.concat(res.grupos);
      this.pagination = res.pagination;

      if (this.filtro.id) {
        this.filtro.id = null;

        if (this.gruposList.length) {
          this.filtro.q = this.gruposList[0].nome;
        }
      }

      if (infiniteScroll) {
        infiniteScroll.target.complete();
      }
    });
  }

  onCancel() {
    this.grupoSelecionado = "";
    this.filtro.q = "";
    this.loadGrupos(null);
    this.pagination = { currentPage: 0, pageCount: 0 };
  }

  onInput() {
    const shouldLoadGrupos = this.filtro.q.length >= 1 || this.filtro.id;
    shouldLoadGrupos ? this.loadGrupos(null) : (this.gruposList = []);

    if (this.filtro.q.length == 0) {
      this.filtro.q = "";
      this.loadGrupos(null);
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async showFilterInstituicao() {
    let indexInstituicaoSelecionada: number = -1;
    const inputs: AlertInput[] = this.instituicaoList.map((instituicao: any, index: number) => {
      if (instituicao.id == this.idInstituicaoFiltro && indexInstituicaoSelecionada === -1) {
        indexInstituicaoSelecionada = index;
      }

      return {
        value: instituicao.id,
        label: instituicao.nome,
        type: "radio",
        checked: instituicao.id == this.idInstituicaoFiltro,
      };
    });

    if (indexInstituicaoSelecionada > -1) {
      const selectedInput = inputs.splice(indexInstituicaoSelecionada, 1)[0];
      inputs.unshift(selectedInput);
    }

    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Filtrar por Instituição:"),
      inputs: inputs,
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Confirmar"),
          handler: (data: any) => {
            this.idInstituicaoFiltro = data;

            const instituicaoSelecionada = this.instituicaoList.find((item: any) => item.id === data);
            this.nomeInstituicaoFiltro = instituicaoSelecionada ? instituicaoSelecionada.nome : null;

            this.notFound = this.idInstituicaoFiltro != this.idInstituicaoLogada;

            // Atualiza os dados
            this.aniversariantes = [];
            this.mostrarContato = false;
            this.aniversariantesMes = [];

            this.pessoaProvider.getAniversariantes(this.idInstituicaoFiltro).subscribe((data) => {
              this.aniversariantes = data.aniversariantes;
              this.mostrarContato = data.acessoContato;
            });
            this.pessoaProvider.getAniversariantesMes(this.idInstituicaoFiltro).subscribe((data) => {
              this.aniversariantesMes = data.aniversariantes;
            });
          },
        },
      ],
    });

    alert.present();
  }

  listInstituicao() {
    this.instituicaoProvider.getInstituicoesVinculadas().subscribe((data) => {
      this.instituicaoList = data;
    });
  }

  get nomeInstituicao() {
    const instituicao = this.instituicaoList.find((item: any) => item.id == this.idInstituicaoFiltro);
    return instituicao ? instituicao.nome : "";
  }

  limparInstituicao() {
    this.idInstituicaoFiltro = this.idInstituicaoLogada;
    this.buscaDiaMes();
  }
}
